import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

import constants from '../Config/constants';
import { mealPlan } from '../RTK/defaultValues';

import DateHelper from './Date';

const mealPlanAutoNext = {}; // will be filled on toggleMealPlanAutoNext method

// this function return array of date string of 3 or 5 depending of meal plan type
const generateSchedule = (type, shouldFormat = true) => {
  dayjs.extend(weekday); // extend dayjs to have .weekday method
  const today = dayjs();
  const isTodaySunday = today.day() === 0;
  const nextMonday = isTodaySunday ? today.add(1, 'day') : dayjs().weekday(8); // Get next Monday (or tomorrow if today is Sunday)
  const format = (d) => {
    if (shouldFormat) {
      return d.format(`${constants.DATE_ONLY_DISPLAY_FORMAT}, YYYY`);
    }
    return d;
  };
  if (type === mealPlan.type.threeDay) {
    return [
      format(nextMonday),
      format(nextMonday.add(2, 'day')),
      format(nextMonday.add(4, 'day')),
    ];
  } else if (type === mealPlan.type.fiveDay) {
    return [
      format(nextMonday),
      format(nextMonday.add(1, 'day')),
      format(nextMonday.add(2, 'day')),
      format(nextMonday.add(3, 'day')),
      format(nextMonday.add(4, 'day')),
    ];
  } else {
    return [];
  }
};

/**
 * Get the meal plan payload
 * @param {{ storeId: string; promoCode?: string; data: any[] }} param0
 * @param  param0.storeId - store identification
 * @param param0.promoCode - optional, selected promo code
 * @param  param0.data - meal plan cart of grouped by day
 * @returns {{
 *    store_id: string;
 *    promo_code?: string;
 *    items: {
 *        quantity: number;
 *        id: string;
 *        extras: string[];
 *        order_date: string;
 *    }[];
 * }}
 */
const getBasePayload = ({ storeId, promoCode, data }) => {
  const schedules = generateSchedule(`${data.length}_day`, false);
  return {
    store_id: storeId,
    promo_code: promoCode,
    items: data.reduce((acc, cart, index) => {
      return [
        ...acc,
        ...cart.items.map((item) => ({
          quantity: item.quantity,
          id: item.id,
          extras: item.extras.map(({ id }) => id),
          order_date: schedules[index].format(constants.DBDATE_FORMAT),
        })),
      ];
    }, []),
  };
};

/**
 * Get day value of meal plan navigation base on day
 * @param {number} dayCount - selected meal plan type day 0, 3 or 5 (0 = no selected, 3 = 3 day plan, 5 = 5 day plan)
 * @param {number} day - selected day 1 - 5 (1 = Monday -> 5 = Friday)
 * @returns {{ label: string; value: number; }}
 */
const getDayValue = (dayCount, day) => {
  const isShort = dayCount === 3;
  const dayName = DateHelper.convertNumberToDay(day);
  const formattedLabel = isShort ? dayName : dayName.substring(0, 3);
  return {
    label: formattedLabel,
    value: day,
  };
};

/**
 * Use for toggling the auto next, this usually called on removed and after triggering the auto next
 * @param {number} day - meal plan day
 * @returns {void}
 */
const toggleMealPlanAutoNext = (day) => {
  mealPlanAutoNext[day] = !mealPlanAutoNext[day];
};

export default {
  mealPlanAutoNext,
  generateSchedule,
  getBasePayload,
  getDayValue,
  toggleMealPlanAutoNext,
};
